"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCapI18nEntries = void 0;
var create_1 = require("./create");
Object.defineProperty(exports, "createCapI18nEntries", { enumerable: true, get: function () { return create_1.createCapI18nEntries; } });
//# sourceMappingURL=index.js.map